import { render, staticRenderFns } from "./UserVerification.vue?vue&type=template&id=7469dbc8&scoped=true"
import script from "./UserVerification.vue?vue&type=script&lang=js"
export * from "./UserVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7469dbc8",
  null
  
)

export default component.exports